<template>
	<div class="pageContainer targetPage flexCloumn">
		<el-row class="searchBar flexBetween" style="flex-wrap: wrap;width:100%">
			<div class="flexStart flex_1" style="flex-wrap:wrap;">
				<span>搜索关键字：</span>
				<el-input v-model="searchForm.keyword" size="small" placeholder="请输入" clearable style="max-width: 200px;" />
        <el-select v-model="searchForm.project_id" size="small" placeholder="选择体育项目" clearable style="margin-left: 10px;">
          <el-option v-for="(item,index) in sportProjects"
                     :label="item.project_name"
                     :value="item.id" :key="index"></el-option>
        </el-select>
				<el-button size="small" icon="el-icon-search" type="primary" style="margin-left: 10px;" @click="getList">查询</el-button>

				<div style="float:right">
					<el-button size="small" icon="el-icon-plus" type="primary" plain
                     style="margin-left: 10px;" @click="handleAdd">新增
					</el-button>
				</div>
			</div>
		</el-row>
		<div class="dividerBar"></div>
    <div style="width: 100%;margin-bottom: 20px;">
      <el-row>
        <el-col :span="6" v-for="(item,index) in tableData" :key="index" style="padding: 25px 10px 0 0">
          <el-card :body-style="{ padding: '0px' }" shadow="hover">
            <div style="height: 250px; position: relative">
              <img :src="item.cover_url" class="image">
              <i class="el-icon-video-play play-btn" @click="handlePlayVideo(item)"></i>
            </div>
            <div style="padding: 14px;">
              <span>{{ item.title }}</span>
              <div style="display: flex;justify-content: space-between">
                <time style="color:#999;padding-top: 10px;">{{ item.pubtime }}</time>
                <div>
                  <el-button type="text" @click="handleModify(item)" style="margin-right: 6px;">编辑</el-button>
                  <el-popconfirm width="250" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info"
                                 iconColor="red" @confirm="handleDel(item)" placement="left" title="是否确定删除？">
                    <el-button slot="reference"  type="text" style="color:red;">删除</el-button>
                  </el-popconfirm>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange" :current-page="page.current_page"
                   :page-size="page.per_page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                   layout="total, prev, pager, next,sizes, jumper" :total="page.count">
    </el-pagination>

		<el-dialog title="添加/修改" :visible.sync="isShowModal" :close-on-click-modal="false" :destroy-on-close="true"
			custom-class="cus_dialog">
			<el-form :model="formData" ref="ruleform" label-width="120px"
				style="max-height: 500px;overflow-y: auto;min-height: 300px;">
        <el-form-item label="体育项目" prop="project_id" :rules="[{required:true,message:'请选择体育项目',trigger:'change'}]">
          <el-select v-model="formData.project_id" placeholder="请选择体育项目" style="width:50%">
            <el-option v-for="(item,index) in sportProjects" :label="item.project_name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
				<el-form-item label="标题" prop="title" :rules="[{required:true,message:'请输入标题',trigger:'blur'}]">
					<el-input v-model.trim="formData.title" />
				</el-form-item>
				<el-form-item label="讲师">
					<el-input v-model.trim="formData.instructor" />
				</el-form-item>
        <el-form-item label="视频简介">
          <el-input type="textarea" :autosize="{minRows:3}" maxlength="500" show-word-limit v-model.trim="formData.video_desc" />
        </el-form-item>
        <el-form-item label="视频封面">
          <div>
<!--            <ul v-if="formData.files && formData.files.length" style="display: inline;list-style: none;vertical-align: top;padding: 0;">
              <li class="custom-upload-list__item" v-for="(file,idx) in formData.files" :key="idx">
                <img :src="file.src || file.fileUrl" alt="" style="width: 100%;height: 100%;">
                <span class="custom-upload-list__item-actions">
                <span class="custom-upload-list__item-delete" @click="handleRemove(idx)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
              </li>
            </ul>-->
            <el-upload class="avatar-uploader"
                       accept="image/*"
                       action=""
                       :http-request="uploadOss"
                       :show-file-list="false"
                       :on-success="(e) => {uploadCover(e,1)}" style="display: inline">
              <img v-if="formData.cover_url" :src="formData.cover_url" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="上传视频" prop="video_url" :rules="[{required:true,message:'请上传视频',trigger: 'change'}]">
          <el-upload class="avatar-uploader"
                     accept=".mp4"
                     action=""
                     :http-request="uploadOss"
                     :show-file-list="false"
                     :before-upload="handleBeforeUpload"
                     :on-success="(e) => {uploadCover(e,2)}" style="display: inline">
            <video class="avatar" v-if="formData.video_url" :src="formData.video_url" controls></video>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div class="el-upload__tip" slot="tip">只能上传mp4文件，且不超过250M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            v-model="formData.pubtime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择发布时间">
          </el-date-picker>
        </el-form-item>
			</el-form>
			<template slot="footer">
        <el-button size="small" type="default" @click="isShowModal = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm">保存</el-button>
      </template>
		</el-dialog>

    <!--视频播放-->
    <el-dialog
      title="视频播放"
      :visible.sync="showPlayDialog"
      width="50%" destroy-on-close>
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </el-dialog>
	</div>
</template>
<script>
import {videoPlayer} from 'vue-video-player'
import tchtree from '../com/tchTree.vue'
export default {
	name: 'dept',
	components: {tchtree,videoPlayer},
	data() {
		return {
			visible: false,
			isShowModal: false,
			isShowModalAuth: false,
			importTeacherShow: false,
			modalTitle: '添加',
			DeptUserDialog: false,
			showDeptroleManage: false,
			activeRoleID: "",
			formData: {
        cover_url: "",
        video_url: "",
        pubtime: this.$moment().format('YYYY-MM-DD HH:mm:ss')
      },
			fgxz: [],
			activeName: 'CN',
			tableData: [],

			teacherList: [],
			editUser: {},
			deptId: null,
			editDeptRole: {},
			deptRoleList: [],
			isShowDeptRole: false,
			biye: 0,

			page: {
				count: 0,
				current_page: 1,
				per_page: 50,
				total_page: 0
			},
			searchForm: {

				ktype: "username",
				keyword: "",
				school_year: ""
			},
			multipleSelection: [],
			treeData: [],
			ckdTreeData: [],
			firstCascaderProps: {
				label: "name",
				children: "children",
			},
			defaultProps: {
				label: 'name',
				value: 'id',
				children: 'children',
				emitPath: false,
				checkStrictly: true
			},
			DataAuth: [],
			showTeacherInfo: false,
			teacher_id: 0,
			schoolYears: [],
      failedImportData: [],
      sportProjects: [],
      showPlayDialog: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
		}
	},

	mounted() {
    this.getSportsProject()
    this.getList()
	},
	methods: {
    getSportsProject() {
      this.$http.post('/api/sport_project_list',{page:1,pagesize:100}).then(res => {
        this.sportProjects = res.data.data
      })
    },
    getList() {
      this.$http.post('/api/teaching_video_list',{
        page: this.page.current_page,
        pagesize: this.page.per_page ? this.page.per_page : 20,
        keyword: this.searchForm.keyword,
        project_id: this.searchForm.project_id,
      }).then(res => {
        this.tableData = res.data.data
        this.page = res.data.page
      })
    },
    handleAdd() {
      this.isShowModal = true;
      this.formData = {
        cover_url: "",
        video_url: "",
        pubtime: this.$moment().format('YYYY-MM-DD HH:mm:ss')
      }
      this.$nextTick(() => {
        this.$refs.ruleform.clearValidate()
      })
    },
		handleModify(row) {
			this.isShowModal = true;
			this.formData = JSON.parse(JSON.stringify(row))
      console.log(this.formData,'##')
			//this.getTechByIds(row.fgxz)
		},
		handleDel(row) {
			this.$http.post("/api/teaching_video_delete", {
				id: String(row.id)
			}).then(res => {
				this.$message.success('删除成功')
				this.getList();
			})
		},

		submitForm() {
			let params = {
				...this.formData
			}
			this.$refs.ruleform.validate(valid => {
        if (valid) {
          this.$http.post("/api/teaching_video_edit", params).then(res => {
            this.$message.success('保存成功')
            this.getList()
            this.isShowModal = false;
          })
        }
      });
		},
    handlePageChange(e) {
      this.page.current_page = e
      this.getList()
    },
    handleSizeChange(e) {
      this.page.per_page = e
      this.getList()
    },
    uploadCover(e,type) {
      if (type == 1) {
        this.formData.cover_url = e.src || e.fileUrl
      } else {
        this.formData.video_url = e.src || e.fileUrl
      }
    },
    handleRemove(idx) {
      this.formData.files.splice(idx, 1)
    },
    handleBeforeUpload(file) {
      if (file.size > 250*1024*1024) {
        this.$message.error('视频不能超过250M')
        return false
      }
    },
    handlePlayVideo(item) {
      this.showPlayDialog = true
      this.playerOptions.sources[0].src = item.video_url
    },
	}
}
</script>
<style scoped lang="less" type="text/less">
.app-container {

	.treeContainer {
		height: 100%;
		background-color: #fff;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
		border: 1px solid rgba(220, 223, 230, 0.6);
		margin-right: 20px;
		padding-right: 10px;

		.treeTitle {
			height: 40px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #409eff;
			padding-left: 6px;
		}
	}
}

.nodetag {
	display: inline-block;
	padding: 0 5px;
	font-size: 12px;
	transform: scale(0.8, 0.8);
	background-color: #409eff;
	color: #fff;
	border-radius: 4px;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}
.avatar {
  width: 140px;
  height: 140px;
  display: block;
}

.image {
  width: 100%;
  height: 100%;
  display: block;
}
.play-btn {
  position: absolute;
  top:50%;
  left:50%;
  transform: translateY(-50%);
  transform: translate(-50%, -50%);
  font-size: 50px;
  color: #fff;
  cursor: pointer;
  background-color: rgba(0,0,0,.5);
  border-radius: 50%;
}
</style>
